import axios from "axios";
import store from "@/store";
import types from "@/store/types";
import router from "@/router";
import utils from "@/utils";
import { Message, Loading } from "element-ui";
//无拦截器的实例
const axiosInstance = axios.create();
// API请求地址
const API_PATH = process.env.VUE_APP_APIPath + "api/";
const API_PATH_V2 = process.env.VUE_APP_APIPath + "v2/api/";
// const API_FOX_MOCK_PATH =
//   "https://mock.apifox.com/m1/3722487-3352926-default/v2/api/";
// const API_FOX_TOKEN = "jOdp12S9QW1scbZDik8im";
// const API_FOX_HEADER = { headers:{apifoxToken: API_FOX_TOKEN }};

// WebSocket请求地址
const WS_PATH = process.env.VUE_APP_WSPath;
// OSS 地址
// eslint-disable-next-line no-unused-vars
const OSS_PATH = process.env.VUE_APP_OSSPath;
// 方法名与哈希值映射
const hashMap = {
  "product/getNavList": "",
  getHomeList: "",
  "product/getListByNavId": "",
  "product/search": "",
  "product/suggestion": "",
  "product/recommend": "",
  "product/recommendHome": "",
  "product/viewed": "",
  "product/getDetail": "",
  "product/notify": "",
  getCartInfo: "",
  addToCart: "",
  delCart: "",
  getCustomerCart: "",
  addToCustomerCart: "",
  changeChooseOfCustomerCart: "",
  deleteCustomerCartItems: "",
  updateCustomerItemOptions: "",
  mergeCart: "",
  getCart: "",
  addCart: "",
  changeChose: "",
  deleteItems: "",
  updateItemOptions: "",
  buyNow: "",
  updateOption: "",
  register: "",
  login: "",
  logout: "",
  forgot: "",
  captcha: "",
  sendSMS: "",
  getProfile: "",
  updateProfile: "",
  changePassword: "",
  code2info: "",
  bindUserInfo: "",
  confirm: "",
  createOrder: "",
  orderPay: "",
  queryOrderPayStatus: "",
  orderList: "",
  orderDetail: "",
  cancelOrder: "",
  addressList: "",
  saveAddress: "",
  delAddress: "",
  setDefAddress: "",
  cms: "",
  //快捷注册
  quickRegisterSmsCode: "",
  quickRegisterByMobile: "",
  getCities: "",
};
// 获取真实的请求地址(Hash码)
const toHash = (key) => hashMap[key] || key;
//
let loading = null;
let loadingCount = 0;
const showLoading = () => {
  if (loadingCount === 0) {
    loading = Loading.service({
      lock: true,
      text: "加载中……",
      background: "rgba(0, 0, 0, 0.7)",
    });
  }
  loadingCount += 1;
};
//
const hideLoading = () => {
  if (loadingCount <= 0) return false;
  loadingCount -= 1;
  if (loadingCount === 0) {
    loading.close();
  }
};
// loading 白名单
const loadingWhiteList = [
  types.ORDER_STATUS,
  types.GET_PRODUCT_LIMIT,
  types.CHECK_NEW_CUSTOMER_STATUS,
];

axios.defaults.withCredentials = true;
// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    const isWhiteList = loadingWhiteList.some((item) => {
      // 匹配方法类型或路径
      if (typeof item === "string" && config.url.includes(item)) {
        return true;
      }
      return false;
    });
    if (!isWhiteList) {
      showLoading();
    }
    // config.headers['X-Request-With'] = 'XMLHttpRequest';
    // if (config.method == "post") {
    //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // }
    if (utils.isLogin()) {
      config.headers["token"] = utils.getToken();
    }
    //OWHS-9910 - 【OT】网站和小程序前端请求header传上级页面URL
    config.headers["m2-present"] = store.state.historyList[0] || "";
    config.headers["m2-forward"] = store.state.historyList[1] || "";
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    hideLoading();
    let isJSONFile = /\.json$/i.test(response.config.url);
    if (isJSONFile) {
      return Promise.resolve(response.data);
    }
    // 1 成功，0 失败，2 需要登录
    if (response?.data?.code == 2) {
      // 登录失效就删除token 防止token白屏
      store.dispatch(types.LOGOUT, () => {
        router.replace({
          name: "Login",
          query: {
            returnUrl: encodeURIComponent(router?.history?.current?.fullPath),
          },
        });
      });
      return Promise.resolve(response.data);
    } else if (response?.data?.code == 1) {
      return Promise.resolve(response.data);
    } else if (response?.config?._silent) {
      // 业务层自己处理 code，不弹全局提示
      return Promise.resolve(response.data);
    } else {
      Message({
        message: response.data?.message,
        type: "warning",
      });
      return Promise.reject(response.data);
    }
  },
  function(error) {
    hideLoading();
    error?.response.data?.message &&
      Message({
        message: error?.response.data?.message,
        type: "warning",
      });
    if (error?.response?.status == 404) {
      console.warn(`接口不存在: ${error?.config?.url}`);
    }
    return Promise.reject(error);
  },
);
// 请求接口实现
export default {
  API_PATH,
  [types.GET_NAV_LIST]: () =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_NAV_LIST)}`),
  [types.GET_HOME_LIST]: () =>
    axios.post(`${API_PATH}${toHash(types.GET_HOME_LIST)}`),
  [types.GET_LIST_BY_NAV_ID]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_LIST_BY_NAV_ID)}`, {
      ...params,
    }),
  [types.GET_LIST_LAYER]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_LIST_LAYER)}`, { ...params }),
  [types.SEARCH]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.SEARCH)}`, { ...params }),
  [types.SEARCH_LAYER]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.SEARCH_LAYER)}`, { ...params }),
  [types.SUGGESTION]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.SUGGESTION)}`, { ...params }),
  [types.RECOMMEND]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.RECOMMEND)}`, { ...params }),
  [types.VIEWED]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.VIEWED)}`, { ...params }),
  [types.GET_DETAIL]: (id, color, sku = "") =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_DETAIL)}`, { id, color, sku }),
  [types.GET_COMMENTS]: (params) =>
    axios.post(`${API_PATH}${toHash(types.GET_COMMENTS)}`, { ...params }),
  [types.ADD_COMMENT]: (params) =>
    axios.post(`${API_PATH}${toHash(types.ADD_COMMENT)}`, { ...params }),
  [types.NOTIFY]: (params) =>
    axios.post(`${API_PATH}${toHash(types.NOTIFY)}`, { ...params }),
  [types.GET_CART_INFO]: (params) =>
    axios.post(`${API_PATH}${toHash(types.GET_CART_INFO)}`, { ...params }),
  [types.ADD_TO_CART]: (params) =>
    axios.post(`${API_PATH}${toHash(types.ADD_TO_CART)}`, { ...params }),
  [types.DEL_CART]: (params) =>
    axios.post(`${API_PATH}${toHash(types.DEL_CART)}`, { ...params }),
  [types.CHANGE_CHOOSE_OF_CUSTOMER_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CHANGE_CHOOSE_OF_CUSTOMER_CART)}`, { ...params }),
  [types.GET_CUSTOMER_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_CUSTOMER_CART)}`, { ...params }),
  [types.ADD_TO_CUSTOMER_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.ADD_TO_CUSTOMER_CART)}`, { ...params }),
  [types.DEL_CUSTOMER_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.DEL_CUSTOMER_CART)}`, { ...params }),
  [types.UPDATE_CUSTOMER_ITEM_OPTIONS]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.UPDATE_CUSTOMER_ITEM_OPTIONS)}`, { ...params }),
  [types.MERGE_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.MERGE_CART)}`, { ...params }),
  [types.GET_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_CART)}`, { ...params }),
  [types.ADD_TO_CART_GUEST]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.ADD_TO_CART_GUEST)}`, { ...params }),
  [types.CHANGE_CHOOSE]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CHANGE_CHOOSE)}`, { ...params }),
  [types.DEL_CART_GUEST]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.DEL_CART_GUEST)}`, { ...params }),
  [types.UPDATE_ITEM_OPTIONS]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.UPDATE_ITEM_OPTIONS)}`, { ...params }),
  [types.BUY_NOW]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.BUY_NOW)}`, { ...params }),
  [types.UPDATE_OPTION]: (params) =>
    axios.post(`${API_PATH}${toHash(types.UPDATE_OPTION)}`, { ...params }),
  [types.REGISTER]: (params) =>
    axios.post(`${API_PATH}${toHash(types.REGISTER)}`, { ...params }),
  [types.LOGIN]: (params) =>
    axios.post(`${API_PATH}${toHash(types.LOGIN)}`, { ...params }),
  [types.LOGOUT]: () => axios.post(`${API_PATH}${toHash(types.LOGOUT)}`),
  [types.FORGOT]: (params) =>
    axios.post(`${API_PATH}${toHash(types.FORGOT)}`, { ...params }),
  [types.CAPTCHA]: () => `${API_PATH}${toHash(types.CAPTCHA)}`,
  [types.SEND_SMS]: (params) =>
    axios.post(`${API_PATH}${toHash(types.SEND_SMS)}`, { ...params }),
  [types.GET_PROFILE]: () =>
    axios.post(`${API_PATH}${toHash(types.GET_PROFILE)}`),
  [types.UPDATE_PROFILE]: (params) =>
    axios.post(`${API_PATH}${toHash(types.UPDATE_PROFILE)}`, { ...params }),
  [types.CHANGE_PASSWORD]: (params) =>
    axios.post(`${API_PATH}${toHash(types.CHANGE_PASSWORD)}`, { ...params }),
  [types.CODE_2_INFO]: (params) =>
    axios.post(`${API_PATH}${toHash(types.CODE_2_INFO)}`, { ...params }),
  [types.BIND_USER_INFO]: (params) =>
    axios.post(`${API_PATH}${toHash(types.BIND_USER_INFO)}`, { ...params }),
  // VERIFY_CART 走主 axios（带 Authorization），拦截器跳过 Message/reject，业务层自己处理 code
  [types.VERIFY_CART]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.VERIFY_CART)}`, { ...params }, { _silent: true }),
  [types.CONFIRM]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CONFIRM)}`, { ...params }),
  [types.CREATE_ORDER]: (params) =>
    axios.post(`${API_PATH}${toHash(types.CREATE_ORDER)}`, { ...params }),
  [types.ORDER_PAY]: (params) =>
    axios.post(`${API_PATH}${toHash(types.ORDER_PAY)}`, { ...params }),
  [types.ORDER_STATUS]: (params) =>
    axios.post(`${API_PATH}${toHash(types.ORDER_STATUS)}`, { ...params }),
  [types.QUERY_ORDER_PAY_STATUS]: (id, callback) => {
    if (!id) return console.log("缺少需要查询的订单编号"), false;
    let token = utils.getToken();
    let ws = new WebSocket(`${WS_PATH}?token=${token}`);
    ws.onopen = function(evt) {
      console.info("WebSocket Connected", evt);
      ws.send(JSON.stringify({ orderId: id }));
    };
    ws.onmessage = function(evt) {
      callback(evt, ws);
    };
    return ws;
  },
  [types.ORDER_LIST]: (params) =>
    axios.post(`${API_PATH}${toHash(types.ORDER_LIST)}`, { ...params }),
  [types.ORDER_DETAIL]: (params) =>
    axios.post(`${API_PATH}${toHash(types.ORDER_DETAIL)}`, { ...params }),
  [types.CANCEL_ORDER]: (params) =>
    axios.post(`${API_PATH}${toHash(types.CANCEL_ORDER)}`, { ...params }),
  [types.SAVE_REFUND_INFO]: (params) =>
    axios.post(`${API_PATH}${toHash(types.SAVE_REFUND_INFO)}`, { ...params }),
  [types.ADDRESS_LIST]: () =>
    axios.post(`${API_PATH}${toHash(types.ADDRESS_LIST)}`),
  [types.SAVE_ADDRESS]: (params) =>
    axios.post(`${API_PATH}${toHash(types.SAVE_ADDRESS)}`, { ...params }),
  [types.DEL_ADDRESS]: (params) =>
    axios.post(`${API_PATH}${toHash(types.DEL_ADDRESS)}`, { ...params }),
  [types.SET_DEF_ADDRESS]: (params) =>
    axios.post(`${API_PATH}${toHash(types.SET_DEF_ADDRESS)}`, { ...params }),
  // [types.GET_OSS_STORES]: () => axiosInstance.get(`${OSS_PATH}data/stores.json`),
  [types.GET_OSS_STORES]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_OSS_STORES)}`, { ...params }),
  [types.GET_OSS_TAGS]: () => axiosInstance.get(`${OSS_PATH}data/tags.json`),
  [types.CMS_PAGE]: (key) =>
    axios.get(`${API_PATH}${toHash(types.CMS_PAGE)}/${key}`),
  [types.CMS_PAGE_V2]: (params) =>
    axios.get(`${API_PATH}${toHash(types.CMS_PAGE_V2)}`, { params }),
  [types.GETPOINTSHISTORY]: (params) =>
    axios.post(`${API_PATH}${toHash(types.GETPOINTSHISTORY)}`, { ...params }),
  [types.QUICK_REGISTER_SMS_CODE]: (params) =>
    axios.post(`${API_PATH}${toHash(types.QUICK_REGISTER_SMS_CODE)}`, {
      ...params,
    }),
  [types.QUICK_REGISTER_BY_MOBILE]: (params) =>
    axios.post(`${API_PATH}${toHash(types.QUICK_REGISTER_BY_MOBILE)}`, {
      ...params,
    }),
  [types.GET_CITIES]: () =>
    axios.get(`${API_PATH_V2}${toHash(types.GET_CITIES)}`),
  [types.GET_COUPON_LIST]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_COUPON_LIST)}`, { ...params }),
  [types.GET_COUPON_DETAIL]: (params) =>
    axios.get(
      `${API_PATH_V2}${toHash(types.GET_COUPON_DETAIL)}?coupon_id=${
        params.coupon_id
      }`,
    ),
  [types.GET_SETTLE_COUPONLIST]: () =>
    axios.get(`${API_PATH_V2}${toHash(types.GET_SETTLE_COUPONLIST)}`),
  [types.CHECKOUT_CONFIRM_DISCOUNT]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CHECKOUT_CONFIRM_DISCOUNT)}`, {
      ...params,
    }),
  [types.GET_PRODUCT_LIMIT]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_PRODUCT_LIMIT)}`, {
      ...params,
    }),
  [types.GET_OSS_COMMON_CONFIG]: () =>
    axiosInstance.get(`${OSS_PATH}data/common-config.json`),
  [types.GET_OSS_MP_CONFIG]: () =>
    axiosInstance.get(`${OSS_PATH}data/mp-config.json`),
  [types.CHECK_NEW_CUSTOMER_STATUS]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CHECK_NEW_CUSTOMER_STATUS)}`, {
      ...params,
    }),
  [types.CHECK_CART_INSTALLMENT]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CHECK_CART_INSTALLMENT)}`, {
      ...params,
    }),
  [types.CHECK_ORDER_INSTALLMENT]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CHECK_ORDER_INSTALLMENT)}`, {
      ...params,
    }),
  [types.GET_PUSH_RECORD]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_PUSH_RECORD)}`, { ...params }),
  [types.SAVE_PUSH_RECORD]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.SAVE_PUSH_RECORD)}`, {
      ...params,
    }),
  [types.AFTER_SALES_OPTIONS]: (params) =>
    axios.get(`${API_PATH_V2}${toHash(types.AFTER_SALES_OPTIONS)}`, {
      ...params,
    }),
  [types.GET_AFTER_SALES_TIPS_JSON]: () =>
    axiosInstance.get(`${OSS_PATH}data/afftersales applications-adress.json`),
  [types.GET_AFTER_SALES_ORDER_LIST]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_AFTER_SALES_ORDER_LIST)}`, {
      ...params,
    }),
  [types.CONFIRM_RECEIPT]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.CONFIRM_RECEIPT)}`, { ...params }),
  [types.GET_LOGISTICS_INFO]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_LOGISTICS_INFO)}`, {
      ...params,
    }),
  [types.APPLY_RMA_SAVE]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.APPLY_RMA_SAVE)}`, { ...params }),
  [types.GET_RMA_DETAIL]: (params) =>
    axios.get(`${API_PATH_V2}${toHash(types.GET_RMA_DETAIL)}`, { params }),
  [types.GET_SEARCH_HOT]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.GET_SEARCH_HOT)}`, { ...params }),
  [types.SAVE_CLICK_ACTION]: (params) =>
    axios.post(`${API_PATH_V2}${toHash(types.SAVE_CLICK_ACTION)}`, {
      ...params,
    }),
};

//
export const BMAP_KEY = "nTO0oQ3m0w6eTDK4tKuBXjDePXYxVGdF";
